import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
import router from './router';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { onError } from "apollo-link-error"
import { HttpLink } from 'apollo-link-http'
import { ApolloLink } from 'apollo-link';
import { errorKind } from './errors';

// Install the vue plugin
Vue.use( VueApollo );

// Name of the localStorage item
var pathArray = window.location.pathname.split('/');
export const AUTH_TOKEN = pathArray.length>1 ? pathArray[1] : 'default';

// Http endpoint
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql';

const httpLink = new HttpLink({
    uri: process.env.VUE_APP_GRAPHQL_HTTP,
    credentials: 'include',
    headers: {
        "event-url": AUTH_TOKEN
    }
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if ( graphQLErrors )
    {
        let authErrors = Vue.prototype._.filter( graphQLErrors, ( graphQLError ) =>
        {
            return errorKind( graphQLError ) === 'authentication';
        } );
        if ( authErrors.length > 0 )
        {
            onLogout()
        }
    }
    else if ( networkError )
    {
        switch ( networkError.statusCode )
        {
            case 401:
                onLogout()
                break;
        }
    }
})

// Config
const defaultOptions = {
    // You can use `https` for secure connection (recommended in production)
    httpEndpoint,
    // You can use `wss` for secure connection (recommended in production)
    // Use `null` to disable subscriptions
    wsEndpoint: null,
    // LocalStorage token
    tokenName: AUTH_TOKEN,
    // Enable Automatic Query persisting with Apollo Engine
    persisting: false,
    // Use websockets for everything (no HTTP)
    // You need to pass a `wsEndpoint` for this to work
    websocketsOnly: false,
    // Is being rendered on the server?
    ssr: false,
    credentials: 'include',

    // Override default apollo link
    // note: don't override httpLink here, specify httpLink options in the
    // httpLinkOptions property of defaultOptions.
    httpLinkOptions: {
        credentials: 'include',
    },
    // Override default cache
    // cache: myCache
    cache: new InMemoryCache( {
        addTypename: false,
    } ),
    defaultHttpLink: false,
    link: ApolloLink.from([errorLink, httpLink]),

    // Override the way the Authorization header is set
    // getAuth: (tokenName) => ...

    // Additional ApolloClient options
    // apollo

    // Client local data (see apollo-link-state)
    // clientState: { resolvers: { ... }, defaults: { ... } }
};

// Call this in the Vue app file
export function createProvider ( options = {} )
{
    // Create apollo client
    const { apolloClient, wsClient } = createApolloClient( {
        ...defaultOptions,
        ...options,
    } );
    apolloClient.wsClient = wsClient;

    // Create vue apollo provider
    const apolloProvider = new VueApollo( {
        defaultClient: apolloClient,
        defaultOptions: {
            $query: {
                fetchPolicy: 'network-only',
            },
        },

    } );

    return apolloProvider;
}

// Manually call this when user log in
export async function onLogin ( apolloClient, token )
{
    if ( typeof localStorage !== 'undefined' && token )
    {
        localStorage.setItem( AUTH_TOKEN, token );
    }
    if ( apolloClient.wsClient )
    {
        restartWebsockets( apolloClient.wsClient );
    }
    try
    {
        await apolloClient.resetStore();
    }
    catch ( e )
    {
        // eslint-disable-next-line no-console
        console.log( '%cError on cache reset (login)', 'color: orange;', e.message );
    }
}

// Manually call this when user log out
export async function onLogout ()
{
    if ( typeof localStorage !== 'undefined' )
    {
        localStorage.removeItem( AUTH_TOKEN );
    }
    try
    {
        if(router.history.current.name !== "Login") {
            router.push( {name: "Login"} );
        }
    }
    catch ( e )
    {
        // eslint-disable-next-line no-console
        console.log( '%cError on cache reset (logout)', 'color: orange;', e.message );
    }
}
